window.CustomPopup = (function () {
  const overlay = document.querySelector(".custom-popup-modal");
  const contentContainer = overlay.querySelector(".render-html");
  const closeButton = overlay.querySelector("button.modal_close_button");

  let contentHTML = ""; // Store the content separately

  function setContent(options = {}) {
    // Build the HTML and store it
    contentHTML = options.data;
  }

  function open() {
    // Inject stored content before opening
    contentContainer.innerHTML = contentHTML;

    overlay.classList.remove("close");
    overlay.classList.add("open");
    document.body.classList.add("Popup_open");
    // addEvents(elements);
  }

  function addEvents(elements) {
  }

  function close() {
    overlay.classList.remove("open");
    overlay.classList.add("close");
    document.body.classList.remove("Popup_open");
  }

  closeButton.addEventListener("click", close);

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) close();
  });

  return {
    setContent,
    open,
    close,
  };
})();
